import i18next from 'i18next';
import { toastErroCarregar } from '../utilidades/toastErroCarregar';
import { removeCacheUsuarioLogado } from '../utilidades/usuarioLogado';

export const linkedinLogin = {
  handleLinkedinLoginCallback(response) {
    document.dispatchEvent(new CustomEvent('linkedinLoginResposta', { detail: { response } }));
  },
  renderizarBotaoLogin(urlAutorizacao) {
    const botao = document.getElementById("botao-linkedin-login"); // O ID do seu botão no HTML
    if (!botao) {
      console.error('Botão LinkedIn login não encontrado!');
      return;
    }
    botao.classList.add('botao-custom-linkedin-login');
    botao.innerHTML = `<i class="bi bi-linkedin h6" style="margin-bottom: 0;"></i><span>LinkedIn</span>`;
    botao.addEventListener('click', (e) => {
      e.preventDefault();
      const width = 500, height = 600;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      window.open(urlAutorizacao, 'Linkedin Login', `width=${width},height=${height},top=${top},left=${left}`);
    });
  },
  callbacksWindow: {
    linkedinAutenticacaoErro(response) {
      toastErroCarregar(response || i18next.t('LoginErro'));
    },
    linkedinAutenticacaoSucesso(response) {
      removeCacheUsuarioLogado();
      linkedinLogin.handleLinkedinLoginCallback(response);
    }
  },
  async init() {
    const configElement = document.getElementById('linkedin-login-config');
    if (!configElement) {
      return;
    }

    const urlAutorizacao = configElement.getAttribute('data-url-autorizacao');
    if (!urlAutorizacao) {
      console.error("Atributo 'data-url-autorizacao' não encontrado no elemento de configuração do LinkedIn.");
      return;
    }

    document.addEventListener('linkedinLoginLogadoDentroDaVaga', async (e) => {
      const { salvarCandidaturaPendente } = await import('../utilidades/candidaturaPendente');
      removeCacheUsuarioLogado();
      const { vagaID, vagaTitulo, vagaUrl, vagaStatus } = e.detail;
      if (vagaStatus) {
        return;
      }
      await salvarCandidaturaPendente(vagaID, vagaTitulo, vagaUrl, true);
    });

    this.renderizarBotaoLogin(urlAutorizacao);

    window.addEventListener('message', (e) => {
      if (this.callbacksWindow[e.data.type]) {
        this.callbacksWindow[e.data.type](e.data.response);
      }
    });
  }
};